import ActionRegister from "../../../../src/mdx/api/endpoints/action-register";
import * as React from 'react';
export default {
  ActionRegister,
  React
};